/**
 * Vergleich der Kacheln auf „Bestellungen" (Persona-Umbau A5): Δ gegen den Ø gleich langer Zeiträume davor, ▲/▼ nur
 * außerhalb der Spanne aller Vergleichszeiträume (ab `marke_ab` Zeiträumen) — sonst liegt der Wert im üblichen
 * Schwankungsbereich, wie die ▲/▼-Regel der Sektion (nur, wo der Unterschied nicht bloß Zufall ist). DB-frei, getestet.
 */
import type { BestellVergleich, BestellVergleichWert } from '../../../helpers/bestellungenData';

export interface KachelDelta {
  /** Veränderung in Prozent gegen den Schnitt; `null`, wenn der Schnitt 0 ist. */
  delta: number | null;
  /** ▲/▼ nur außerhalb der Spanne. */
  marke: 'up' | 'down' | null;
}

export function kachelDelta(jetzt: number, v: BestellVergleichWert, zeitraeume: number, markeAb: number): KachelDelta {
  const delta = v.schnitt > 0 ? ((jetzt - v.schnitt) / v.schnitt) * 100 : null;
  const geprueft = zeitraeume >= markeAb;
  const marke = !geprueft ? null : jetzt > v.max ? 'up' : jetzt < v.min ? 'down' : null;
  return { delta, marke };
}

/** Etikett mit Fenster (Regel 2): „gegen Ø der 12 Wochen davor", „gegen Ø von 2 × 30 Tagen davor", „gegen die 93 Tage davor". */
export function vergleichEtikett(v: Pick<BestellVergleich, 'zeitraeume' | 'tage'>): string {
  if (v.zeitraeume <= 1) return `gegen die ${v.tage} ${v.tage === 1 ? 'Tag' : 'Tage'} davor`;
  if (v.tage === 7) return `gegen Ø der ${v.zeitraeume} Wochen davor`;
  if (v.tage === 1) return `gegen Ø der ${v.zeitraeume} Tage davor`;
  // „Ø von 10 × 8 Tagen" las sich nicht (Runde 2, Marketing).
  return `gegen Ø der ${v.zeitraeume} gleich langen Zeiträume davor (je ${v.tage} Tage)`;
}
